
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  useContext,
} from '@nuxtjs/composition-api';
import { saveLorgarAwardShown, getLorgarAwardShown } from '~/helpers/lsHelper';

interface AwardNotifications {
  INVITATION_SENT: string;
  USER_EMAIL_ALREADY_EXIST: string;
  INVITATION_ALREADY_EXISTS: string;
  DEFAULT_ERROR: string;
}

export default defineComponent({
  props: {
    awardsModal: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    const awardsModalRef = ref();
    const award = ref(null);
    const awardsShown = ref(false);
    // @ts-ignore
    const { $lorgarPlatformApi } = useContext();

    const formFields = reactive({
      email: '',
    });

    onMounted(() => {
      awardsShown.value = !!getLorgarAwardShown();
      if (!awardsShown.value) {
        // eslint-disable-next-line no-use-before-define
        fetchAwards();
      }
    });

    const getErrorNotificationText = (
      dictionary: AwardNotifications,
      errorMessage?: string
    ) => {
      const notificationKey = errorMessage as keyof AwardNotifications;

      if (dictionary[notificationKey]) return dictionary[notificationKey];

      return dictionary.DEFAULT_ERROR;
    };

    const fetchAwards = async () => {
      try {
        award.value = (await $lorgarPlatformApi.getAwards()).data?.result;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    const resetForm = () => {
      Object.assign(formFields, {
        email: '',
      });
    };

    const handleForm = async (resetValidation: any) => {
      const notifications: AwardNotifications =
        props.awardsModal.notifications || {};

      let notificationText: string = notifications.INVITATION_SENT;
      let status: 'success' | 'error' = 'success';
      try {
        await $lorgarPlatformApi.sendInvite(formFields.email);
      } catch (error) {
        notificationText = getErrorNotificationText(
          notifications,
          // @ts-ignore
          error.response?.data?.message
        );
        status = 'error';
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
        resetForm();
        resetValidation();
        emit('submit', { status, notificationText });
      }
    };

    const handleClosed = () => {
      emit('closed');
    };

    const open = () => {
      awardsModalRef.value?.open();
      saveLorgarAwardShown();
    };

    const alreadyShown = () => !!getLorgarAwardShown();

    return {
      awardsModalRef,
      award,
      awardsShown,
      formFields,
      open,
      alreadyShown,
      handleForm,
      resetForm,
      handleClosed,
    };
  },
});
